import brand from '@helpers/brand';
import styled from 'styled-components';
import { Containers } from '@stories/Widgets/YourSolution/YS/Components/Shared/Step.styles';
import { fluid } from '@helpers/fluid';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { BreadcrumbsStyles } from '@stories/Widgets/Meta/Breadcrumbs/Breadcrumbs.styles';
import { Grid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
const Container = styled.div `
  position: relative;
  padding: 62px 0px;

  color: ${brand.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${fluid(250, 425)};
  overflow: hidden;
`;
const ContentWrapper = styled(Containers.FullWidth) `
  --searchHeight: 83px;
  position: relative;
  z-index: 4;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;

  padding-bottom: 0 !important;

  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
const BreadcrumbsWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 4;

  ${Grid.Default} ${Grid.Default} {
    padding: 0;
  }

  ${BreadcrumbsStyles.Wrapper} {
    color: ${brand.white};

    a {
      color: ${brand.white};
    }
  }
`;
const BackgroundImage = styled.img `
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;
const BackgroundOverlayTint = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.7);
`;
const GridOverride = styled(Grid.Default) `
  width: 100%;
  @media ${until(Device.TabletLarge)} {
    padding-top: 28px;
    ${() => BreadcrumbsStyles.Wrapper} {
      margin: 0;
    }
  }
`;
const InnerContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${fluid(15, 35)};
  z-index: 3;

  @media ${from(Device.DesktopSmall)} {
    max-width: 1400px;
  }

  ${ButtonStyles.Button} {
    margin: auto;
  }
`;
const Heading = styled.h1 `
  color: ${brand.white};
  font-size: ${fluid(19, 35)};
  line-height: ${fluid(25, 45)};
  letter-spacing: 0.02em;
  margin: 0;
`;
const CourseDetails = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${fluid(20, 40)};
  text-transform: uppercase;
  font-size: ${fluid(11, 18)};
  font-weight: 700;

  @media ${until(Device.Mobile)} {
    flex-wrap: wrap;
  }
`;
const CourseDetail = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  color: ${brand.white};

  svg {
    fill: ${brand.white};
    width: ${fluid(24, 32)};
  }
`;
const Paragraph = styled.p `
  font-size: ${fluid(17, 20)};
  line-height: ${fluid(22, 26)};
  font-weight: 300;
  margin: auto;
  color: ${brand.white};

  @media ${from(Device.TabletLarge)} {
    max-width: 90%;
  }
`;
const Button = styled(LinkButton) `
  ${ButtonStyles.Inner} {
    padding: ${fluid(9, 18)} 100px;
  }
  align-self: flex-start;
`;
export const TrainingCoursesHeroStyles = {
    Container,
    BreadcrumbsWrapper,
    BackgroundImage,
    BackgroundOverlayTint,
    ContentWrapper,
    Heading,
    CourseDetails,
    CourseDetail,
    Paragraph,
    Button,
    InnerContent,
    GridOverride,
};
